import { Link } from "react-router-dom";
import { categoryMeta, videos, type VideoType } from "@/mocks/videos";
import { typeOrder } from "@/utils/format";

const icons: Record<VideoType, string> = {
  movie: "ri-film-line",
  drama: "ri-tv-2-line",
  variety: "ri-mic-line",
  short: "ri-video-line",
};

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 md:px-8">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {typeOrder.map((type) => {
            const meta = categoryMeta[type];
            const count = videos.filter((v) => v.type === type).length;
            return (
              <Link
                key={type}
                to={`/category/${meta.slug}`}
                className="group p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-colors">
                    <i className={`${icons[type]} text-2xl`}></i>
                  </span>
                  <span className="text-xs font-medium px-2 py-1 rounded-full bg-secondary-100 text-secondary-900">
                    {count} 部
                  </span>
                </div>
                <h3 className="mt-4 text-lg font-semibold text-foreground-950">
                  {meta.label}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-500 line-clamp-2">
                  {meta.intro}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                  进入频道
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}